import mixins from 'vue-typed-mixins';

import { 勘定科目ListItemResponse, 部門ListItemResponse } from '@/openapi/user';

import C科目別計画 from '@/components/科目別計画/科目別計画.vue';
import C部門Select from '@/components/部門Select/部門Select.vue';

import PlbscfKeystrokeInputableTextMixin, {
  PlbscfInputableTextId,
} from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 業績予測三表Mixin from '@/entries/user/mixins/業績予測三表Mixin';
import 計画損益計算表Mixin from '@/entries/user/mixins/計画損益計算表Mixin';

import { PlbscfListItem } from '@/classes/service/AbstractPlbscfService';
import { Pl, 科目別計画 } from '@/classes/service/Abstract計画PlbscfService';
import 業績予測Service from '@/classes/service/モニタリング/業績予測Service';

export default mixins(PlbscfKeystrokeInputableTextMixin, RoutesMixin, 業績予測三表Mixin, 計画損益計算表Mixin).extend({
  name: 'C業績予測損益計算書',

  components: {
    C部門Select,
    C科目別計画,
  },

  data(): {
    勘定科目s: 勘定科目ListItemResponse[];
    部門s: 部門ListItemResponse[];
    部門pk: number | undefined;
  } {
    return {
      勘定科目s: this.service.get勘定科目s,
      部門s: this.service.get部門s,
      部門pk: undefined,
    };
  },

  computed: {
    is部門合計(): boolean {
      return this.部門pk === undefined;
    },
    pl(): Pl | undefined {
      return this.計画Plbscf.pls.find((pl) => pl.部門pk === this.部門pk);
    },
    plListItems(): PlbscfListItem[] {
      if (this.pl === undefined) return [];
      return 業績予測Service.getVisibleListBy基準値(this.pl.list, this.vモニタリング業績予測基準値);
    },
    科目別計画(): 科目別計画 | undefined {
      return this.計画Plbscf.科目別損益計算書.科目別計画s.find((item) => item.部門pk === this.部門pk);
    },
    map(): PlbscfInputableTextId[][] {
      if (this.is部門合計 || this.pl === undefined) return [];
      return this.createMap(this.plListItems, this.readonlyMonthIndex);
    },
  },

  destroyed(): void {
    this.inactivate科目別損益計算表();
  },

  watch: {
    is科目別損益計算表(): void {
      if (this.is科目別損益計算表) return;
      this.setFirstId();
    },
    部門pk(): void {
      if (this.is部門合計) return;
      this.setFirstId();
    },
    keystrokeResetCount(): void {
      this.setFirstId();
    },
  },
});
